module.exports = __webpack_public_path__ + "static/media/bg_02.bae4247a.jpg";